/**
 * Section: Hub catalogue feuillage — catégories / sous-catégories, filtre prix (colonne + mobile).
 */

(function () {
  'use strict';

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get(name);
    } catch (err) {
      return null;
    }
  }

  function sortVisibleProducts(container, order) {
    var wrap = container.querySelector('.fb-hub__products');
    if (!wrap) return;
    var nodes = Array.prototype.slice.call(wrap.querySelectorAll('[data-fb-product]'));
    var visible = nodes.filter(function (a) {
      return !a.hidden;
    });
    var hidden = nodes.filter(function (a) {
      return a.hidden;
    });
    visible.sort(function (a, b) {
      var la = a.querySelector('.fb-hub__product-label') || a.querySelector('.product-item__title');
      var lb = b.querySelector('.fb-hub__product-label') || b.querySelector('.product-item__title');
      var ta = la ? la.textContent.trim() : (a.textContent || '').trim();
      var tb = lb ? lb.textContent.trim() : (b.textContent || '').trim();
      if (order === 'za') return tb.localeCompare(ta, 'fr', { sensitivity: 'base' });
      return ta.localeCompare(tb, 'fr', { sensitivity: 'base' });
    });
    visible.concat(hidden).forEach(function (node) {
      wrap.appendChild(node);
    });
  }

  function parsePriceNumber(raw) {
    if (raw == null) return NaN;
    var s = String(raw).trim();
    if (!s) return NaN;
    var normalized = s.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.]/g, '');
    if (!normalized) return NaN;
    var n = Number(normalized);
    return isNaN(n) ? NaN : n;
  }

  function initHubNavigator(container) {
    if (!container || container.dataset.hubNavBound === '1') return;
    if (container.getAttribute('data-fb-hub-mode') !== 'link') return;

    var dialog = container.querySelector('[data-fb-filter-dialog]');

    function catButtons() {
      return container.querySelectorAll('[data-fb-cat][data-fb-cat-key]');
    }
    function subcatCards() {
      return container.querySelectorAll('[data-fb-subcat][data-fb-subcat-key]');
    }
    function productLinks() {
      return container.querySelectorAll('[data-fb-product]');
    }

    var activePriceFilter = 'all';
    var navMode = 'cat';
    var navKey = '';

    function updateProductCount() {
      var el = container.querySelector('[data-fb-product-count]');
      if (!el) return;
      var n = 0;
      productLinks().forEach(function (a) {
        if (!a.hidden) n += 1;
      });
      el.textContent = String(n);
    }

    function productPrice(node) {
      if (!node) return NaN;
      var rawAttr = node.getAttribute('data-fb-price-value') || '';
      var n = parsePriceNumber(rawAttr);
      if (!isNaN(n)) return n;
      var priceEl = node.querySelector('.price-item--regular, .fb-hub__product-price, .product-item__price');
      return parsePriceNumber(priceEl ? priceEl.textContent : '');
    }

    function matchesPriceFilter(node) {
      if (activePriceFilter === 'all') return true;
      var p = productPrice(node);
      if (isNaN(p)) return false;
      if (activePriceFilter === 'lt50') return p < 50;
      if (activePriceFilter === '50-100') return p >= 50 && p <= 100;
      if (activePriceFilter === '100-200') return p > 100 && p <= 200;
      if (activePriceFilter === 'gt200') return p > 200;
      return true;
    }

    function setActivePriceButton(value) {
      container.querySelectorAll('[data-fb-price-filter]').forEach(function (btn) {
        var active = (btn.getAttribute('data-fb-price-filter') || 'all') === value;
        btn.classList.toggle('is-selected', active);
      });
    }

    var flat = container.getAttribute('data-fb-hub-flat') === '1';

    function singleCategoryMode() {
      return catButtons().length === 1;
    }

    function isOrphanProduct(a) {
      var pSub = a.getAttribute('data-fb-parent-subcat') || '';
      var pCat = a.getAttribute('data-fb-parent-cat') || '';
      return pSub === '' && pCat === '';
    }

    function computeNavVisible(a) {
      if (flat) return true;
      var pSub = a.getAttribute('data-fb-parent-subcat') || '';
      var pCat = a.getAttribute('data-fb-parent-cat') || '';
      var oneCat = singleCategoryMode();
      var orphan = pSub === '' && pCat === '';
      if (navMode === 'sub') {
        var show = pSub === navKey;
        if (!show && oneCat && orphan) show = true;
        return show;
      }
      var direct = pSub === '' && pCat === navKey;
      var orphanVis = oneCat && orphan;
      return direct || orphanVis;
    }

    function refreshProductVisibility() {
      productLinks().forEach(function (a) {
        a.hidden = !(computeNavVisible(a) && matchesPriceFilter(a));
      });
    }

    function onPriceFilterSelect(value) {
      activePriceFilter = value || 'all';
      setActivePriceButton(activePriceFilter);
      refreshProductVisibility();
      updateProductCount();
      var sortElP = container.querySelector('[data-fb-sort]');
      if (sortElP) sortVisibleProducts(container, sortElP.value || 'az');
      if (dialog && typeof dialog.close === 'function') dialog.close();
    }

    if (flat && productLinks().length) {
      container.dataset.hubNavBound = '1';
      setActivePriceButton(activePriceFilter);
      refreshProductVisibility();
      updateProductCount();
      var sortElFlat = container.querySelector('[data-fb-sort]');
      if (sortElFlat) {
        sortElFlat.addEventListener('change', function () {
          sortVisibleProducts(container, sortElFlat.value || 'az');
        });
        sortVisibleProducts(container, sortElFlat.value || 'az');
      }
      container.addEventListener('click', function (e) {
        var priceBtn = e.target.closest('[data-fb-price-filter]');
        if (priceBtn && container.contains(priceBtn)) {
          e.preventDefault();
          onPriceFilterSelect(priceBtn.getAttribute('data-fb-price-filter') || 'all');
          return;
        }
        var t = e.target;
        if (t.closest('[data-fb-open-filter]')) {
          e.preventDefault();
          if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
          return;
        }
        if (t.closest('[data-fb-close-filter]')) {
          e.preventDefault();
          if (dialog && typeof dialog.close === 'function') dialog.close();
        }
      });
      if (dialog) {
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
      }
      return;
    }

    var cats = catButtons();

    if (!cats.length || !productLinks().length) return;

    var qsCat = getQueryParam('fb_cat');
    var qsSub = getQueryParam('fb_sub');
    var qsProd = getQueryParam('fb_product');

    function setQueryParams(next) {
      try {
        var u = new URL(window.location.href);
        Object.keys(next).forEach(function (k) {
          var v = next[k];
          if (v === null || v === undefined || v === '') u.searchParams.delete(k);
          else u.searchParams.set(k, v);
        });
        window.history.replaceState({}, '', u.toString());
      } catch (err) {
        // ignore
      }
    }

    function setActiveCat(btn) {
      if (!btn) return;
      var key = btn.getAttribute('data-fb-cat-key') || '';
      catButtons().forEach(function (b) {
        var active = (b.getAttribute('data-fb-cat-key') || '') === key;
        b.classList.toggle('is-active', active);
        if (b.getAttribute('role') === 'tab') {
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        }
      });
    }

    function setActiveSubcat(card) {
      if (!card) {
        subcatCards().forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        return;
      }
      var key = card.getAttribute('data-fb-subcat-key') || '';
      subcatCards().forEach(function (c) {
        var active = (c.getAttribute('data-fb-subcat-key') || '') === key;
        c.classList.toggle('is-selected', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function setActiveProductLink(el) {
      productLinks().forEach(function (a) {
        var active = el && a === el;
        a.classList.toggle('is-selected', !!active);
      });
    }

    function filterSubcats(catKey) {
      var firstVisible = null;
      subcatCards().forEach(function (card) {
        var parent = card.getAttribute('data-fb-parent-cat') || '';
        var visible = parent === catKey;
        card.hidden = !visible;
        if (visible && !firstVisible) firstVisible = card;
      });
      return firstVisible;
    }

    function findCatByKey(key) {
      var found = null;
      catButtons().forEach(function (b) {
        if (found) return;
        if ((b.getAttribute('data-fb-cat-key') || '') === key) found = b;
      });
      return found;
    }

    function findSubcatByKey(key) {
      var found = null;
      subcatCards().forEach(function (c) {
        if (found) return;
        if ((c.getAttribute('data-fb-subcat-key') || '') === key) found = c;
      });
      return found;
    }

    function findProductByKey(key) {
      var found = null;
      productLinks().forEach(function (a) {
        if (found) return;
        if ((a.getAttribute('data-fb-product-key') || '') === key) found = a;
      });
      return found;
    }

    function selectSubcat(subCard, highlightProductKey) {
      if (!subCard) return;
      var subKey = subCard.getAttribute('data-fb-subcat-key') || '';
      navMode = 'sub';
      navKey = subKey;
      setActiveSubcat(subCard);
      setQueryParams({ fb_sub: subKey });
      refreshProductVisibility();
      if (highlightProductKey) {
        var pl = findProductByKey(highlightProductKey);
        if (pl && !pl.hidden) setActiveProductLink(pl);
        else setActiveProductLink(null);
      } else {
        setActiveProductLink(null);
      }
      updateProductCount();
      var sortEl = container.querySelector('[data-fb-sort]');
      if (sortEl) sortVisibleProducts(container, sortEl.value || 'az');
    }

    function selectCat(catBtn, opts) {
      if (!catBtn) return;
      var catKey = catBtn.getAttribute('data-fb-cat-key') || '';
      setActiveCat(catBtn);

      var requestedSub = opts && opts.subKey ? findSubcatByKey(opts.subKey) : null;
      var subToSelect = null;
      if (requestedSub && (requestedSub.getAttribute('data-fb-parent-cat') || '') === catKey) {
        filterSubcats(catKey);
        subToSelect = requestedSub;
      } else {
        subToSelect = filterSubcats(catKey);
      }

      if (subToSelect) {
        selectSubcat(subToSelect, opts && opts.productKey ? opts.productKey : null);
      } else {
        setActiveSubcat(null);
        navMode = 'cat';
        navKey = catKey;
        setQueryParams({ fb_sub: '' });
        refreshProductVisibility();
        if (opts && opts.productKey) {
          var pl = findProductByKey(opts.productKey);
          if (pl && !pl.hidden) setActiveProductLink(pl);
          else setActiveProductLink(null);
        } else {
          setActiveProductLink(null);
        }
        updateProductCount();
        var sortElNoSub = container.querySelector('[data-fb-sort]');
        if (sortElNoSub) sortVisibleProducts(container, sortElNoSub.value || 'az');
      }

      setQueryParams({ fb_cat: catKey });
    }

    container.addEventListener('click', function (e) {
      var priceBtn = e.target.closest('[data-fb-price-filter]');
      if (priceBtn && container.contains(priceBtn)) {
        e.preventDefault();
        onPriceFilterSelect(priceBtn.getAttribute('data-fb-price-filter') || 'all');
        return;
      }

      var t = e.target;
      if (t.closest('[data-fb-open-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        return;
      }
      if (t.closest('[data-fb-close-filter]')) {
        e.preventDefault();
        if (dialog && typeof dialog.close === 'function') dialog.close();
        return;
      }

      var catBtn = t.closest('[data-fb-cat][data-fb-cat-key]');
      if (catBtn && container.contains(catBtn)) {
        e.preventDefault();
        selectCat(catBtn, { subKey: null, productKey: null });
        return;
      }

      var subCard = t.closest('[data-fb-subcat][data-fb-subcat-key]');
      if (subCard && container.contains(subCard)) {
        e.preventDefault();
        selectSubcat(subCard, null);
        if (dialog && subCard.closest && subCard.closest('[data-fb-filter-dialog]')) {
          dialog.close();
        }
      }
    });

    var sortEl = container.querySelector('[data-fb-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortVisibleProducts(container, sortEl.value || 'az');
      });
    }

    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    }

    container.dataset.hubNavBound = '1';

    var startCat = (qsCat && findCatByKey(qsCat)) || catButtons()[0];
    selectCat(startCat, { subKey: qsSub, productKey: qsProd });
    setActivePriceButton(activePriceFilter);
  }

  function run() {
    document.querySelectorAll('.fb-hub[data-fb-hub-mode="link"]').forEach(function (el) {
      initHubNavigator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.fb-hub[data-fb-hub-mode="link"]');
    if (root) initHubNavigator(root);
  });
})();
